import { File } from 'app/models/file';

export class StadiumCamera {
  posName?: string;
  status: string;
  type: string;
  description?: string;
  file?: File;
  files: File[];
}



// WEBPACK FOOTER //
// ./src/app/models/stadium-camera.ts